(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

//$(document)ready(function(){

/////////////////////////////////////////////////////////////////////////

$('.slider').each(function () {
  var $this = $(this); //aktuelle element

  var $group = $this.find('.slide-group'); //schließt folien ein

  var $slides = $this.find('.slide'); //alle folien

  var buttonArray = []; //array für die schaltfächen

  var timeout = void 0;
  var currentIndex = 0; //die indexnummer der aktuellen folien

  function move(newIndex) {
    //wechsle von der alten zur neuen folie

    var animateLeft = void 0,
      slideLeft = void 0;
    advance(); //aufruf der fkt advance bei bewegung des sliders

    //wenn eine ani läuft und die folie falsch ist abbrechen

    if ($group.is(':animated') || currentIndex === newIndex) {
      return;
    }
    buttonArray[currentIndex].removeClass('active');
    buttonArray[newIndex].addClass('active');
    if (newIndex > currentIndex) {
      slideLeft = '100%'; //plaziere die folie nach rechts und animiere sie nach links

      animateLeft = '-100%'; //animiere nach links
    } else {
      slideLeft = '-100%';
      animateLeft = '100%';
    }

    //plazieren und sichtbar machen

    $slides.eq(newIndex).css({
      left: slideLeft,
      display: 'block'
    });
    $group.animate({
      left: animateLeft
    }, 1000, function () {
      $slides.eq(currentIndex).css({
        display: 'none'
      }); //verbergen der alten folie

      $slides.eq(newIndex).css({
        left: 0
      }); //position der folie

      $group.css({
        left: 0
      }); //position der group

      currentIndex = newIndex;
    });
  } //endMove

  function advance() {
    //richtet den timer ein

    clearTimeout(timeout); //löschte den timer in timout

    timeout = setTimeout(function () {
      if (currentIndex < $slides.length - 1) {
        //solange die letzte folie noch nicht erreicht ist

        move(currentIndex + 1);
      } else {
        move(0); //wechsel zur ersten folie
      }
    }, 3000); //wartezeit des timers
  } //endeAdvance

  //erstellung der schaltflaeche für jeden index

  $.each($slides, function (index) {
    var $button = $('<div class="slide-btn"></div>');
    if (index == currentIndex) {
      //beim index der aktuellen folie

      $button.addClass('active'); //füge den button die class active hinzu
    }

    $button.on('click', function () {
      move(index);
    }).appendTo('.slide-buttons'); //schaltfläche anhängen

    buttonArray.push($button);
  });
  advance(); //starte den timer
});

/////////////////////////////////////////////////////////////////////////

//});

},{}]},{},[1]);
